(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ayanoa-before-after"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input',event=>{
  const input=event.target;
  if(!input.classList.contains('ay-before-after-range'))return;
  const comparison=input.closest('.ay-before-after');
  comparison.style.setProperty('--reveal',input.value+'%');
  input.setAttribute('aria-valuetext',input.value+' pour cent de la photo avant');
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayanoa-large-timeline"] && !Shopify.designMode) return;
  try {
    function initAyJourneys(){
document.querySelectorAll('[data-ay-journey]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
let pending=false;
const update=()=>{pending=false;const rect=root.getBoundingClientRect();const position=innerHeight*.65-rect.top;root.style.setProperty('--progress',Math.max(0,position-29)+'px');root.querySelectorAll('.ay-journey-step').forEach(step=>step.classList.toggle('is-active',step.getBoundingClientRect().top<innerHeight*.65));};
const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(update);}};
window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});update();
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAyJourneys);else initAyJourneys();
document.addEventListener('shopify:section:load',initAyJourneys);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayanoa-period-comparator"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const tab=event.target.closest('[data-period-tab]');
  if(!tab)return;
  const root=tab.closest('.ay-period-comparator');
  if(!root)return;
  root.querySelectorAll('[data-period-tab]').forEach(t=>{t.classList.toggle('is-active',t===tab);t.setAttribute('aria-selected',t===tab?'true':'false');});
  root.querySelectorAll('[data-period-panel]').forEach(p=>{p.classList.toggle('is-active',p.dataset.periodPanel===tab.dataset.periodTab);});
});
document.addEventListener('input',event=>{
  const input=event.target;
  if(!input.classList.contains('ay-before-after-range'))return;
  const comparison=input.closest('.ay-before-after');
  comparison.style.setProperty('--reveal',input.value+'%');
  input.setAttribute('aria-valuetext',input.value+' pour cent de la photo avant');
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayanoa-progress-comparison"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
const tab=event.target.closest('[data-progress-tab]');if(!tab)return;
const root=tab.closest('[data-progress-compare]');
root.querySelectorAll('[data-progress-tab]').forEach(t=>t.setAttribute('aria-selected',String(t===tab)));
root.querySelector('.ay-progress-after').src=tab.dataset.photo;
root.querySelector('[data-progress-week]').textContent=tab.dataset.week;
root.querySelector('[data-progress-title]').textContent=tab.dataset.title;
root.querySelector('[data-progress-range]').value=50;
root.querySelector('.ay-progress-frame').style.setProperty('--split','50%');
});
document.addEventListener('input',event=>{if(!event.target.matches('[data-progress-range]'))return;event.target.closest('.ay-progress-frame').style.setProperty('--split',event.target.value+'%');});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayanoa-reference-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const root=event.target.closest('[data-reference-commerce]');if(!root)return;const choice=event.target.closest('.ay-ref-choice-head');if(choice){const selected=choice.closest('[data-reference-choice]');root.querySelectorAll('[data-reference-choice]').forEach(card=>{card.classList.toggle('is-selected',card===selected);card.querySelector('button').setAttribute('aria-pressed',String(card===selected));});const duo=selected.dataset.referenceChoice==='2';root.querySelector('[data-ref-price]').textContent=duo?'34,95 €':'24,95 €';root.querySelector('[data-ref-compare]').textContent=duo?'101,75 €':'29,95 €';}const toggle=event.target.closest('.ay-ref-switch');if(toggle)toggle.setAttribute('aria-checked',String(toggle.getAttribute('aria-checked')!=='true'));if(event.target.closest('[data-reference-atc]'))root.querySelector('.ay-ref-feedback').hidden=false;});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayanoa-results-timeline"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const stage=event.target.closest('[data-stage]');if(!stage)return;const timeline=stage.closest('[data-results-timeline]');if(!timeline)return;const index=Number(stage.dataset.stage);timeline.style.setProperty('--active-stage',index);timeline.querySelectorAll('[data-stage]').forEach(item=>{const itemIndex=Number(item.dataset.stage);item.classList.toggle('is-current',item===stage);item.classList.toggle('is-done',itemIndex<=index);item.setAttribute('aria-pressed',String(item===stage));});});
  } catch(e) { console.error(e); }
})();

})();
